class EquipmentService {
    axiosInstance;
    static apps = {
        wayste: {
            equipmentList: [],
        },
    };
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    wayste = {
        containerAssignment: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/container-assignment', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/container-assignment/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/container-assignment`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/dumpster/wayste/container-assignment/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/container-assignment/${id}`);
                return response.data;
            },
        },
        containerType: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/container-type', input);
                this.wayste.containerType.setEquipmentListInMemory();
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/container-type/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/container-type`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/dumpster/wayste/container-type/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/container-type/${id}`);
                return response.data;
            },
            setEquipmentListInMemory: async () => {
                const data = await this.wayste.containerType.query({ limit: 1000 });
                EquipmentService.apps.wayste.equipmentList = data.results;
            },
            getEquipmentListFromMemory: () => {
                return EquipmentService.apps.wayste.equipmentList;
            },
        },
        activityRecord: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/equipment-activity-record', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/equipment-activity-record/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/equipment-activity-record`, { params: query });
                return data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/equipment-activity-record/${id}`);
                return response.data;
            },
        },
        taggedContainer: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/tagged-container', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/tagged-container/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/tagged-container`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/dumpster/wayste/tagged-container/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/tagged-container/${id}`);
                return response.data;
            },
        },
        untaggedContainer: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/untagged-container', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/untagged-container/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/untagged-container`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/dumpster/wayste/untagged-container/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/untagged-container/${id}`);
                return response.data;
            },
        },
        vehicle: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/dumpster/wayste/vehicle', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/vehicle/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/vehicle`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/dumpster/wayste/vehicle/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/dumpster/wayste/vehicle/${id}`);
                return response.data;
            },
        },
        inventory: {
            query: async (query) => {
                const response = await this.axiosInstance.mainInstance.get(`/dumpster/wayste/inventory`, {
                    params: query,
                });
                return response.data;
            },
            subscription: {
                query: (query) => {
                    return this.axiosInstance.socket.connect(`/dumpster/wayste/inventory`, {
                        params: query,
                    });
                },
            },
        },
    };
}
export default EquipmentService;
//# sourceMappingURL=Equipment.service.js.map